import firebase from 'firebase/compat/app';
import 'firebase/compat/analytics';
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyD6xvLwubNK71uTlzfCcZUyVoQI7GCPHMo",
    authDomain: "devboard-727c8.firebaseapp.com",
    projectId: "devboard-727c8",
    storageBucket: "devboard-727c8.firebasestorage.app",
    messagingSenderId: "204309510453",
    appId: "1:204309510453:web:7b26005e29d9dd477d747c",
    measurementId: "G-X3GX3SB3G8",
    databaseURL: "https://devboard-727c8-default-rtdb.firebaseio.com"
  };

  // Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
firebase.analytics();

export const auth = getAuth();
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export default app;
